import React from 'react';
import '../SharedControlPanel.scss';
import './TranscoderVideoPanel.scss';
import VideoQualityInput from '../../../../InputComponents/VideoQualityInput/VideoQualityInput';
import { VideoQualityEnum } from '../../../../../types/enums/VideoQualityEnum';
import VideoBitrateInput from '../../../../InputComponents/VideoBitrateInput/VideoBitrateInput';
import VideoBitrateMaxInput from '../../../../InputComponents/VideoBitrateMaxInput/VideoBitrateMaxInput';
import VideoBitrateBufferSizeInput from '../../../../InputComponents/VideoBitrateBufferSizeInput/VideoBitrateBufferSizeInput';
import VideoQualityCrfInput from '../../../../InputComponents/VideoQualityCrfInput/VideoQualityCrfInput';
import VideoFixedQualityQpInput from '../../../../InputComponents/VideoFixedQualityQpInput/VideoFixedQualityQpInput';
import VideoPixelFormatInput from '../../../../InputComponents/VideoPixelFormatInput/VideoPixelFormatInput';
import VideoPresetInput from '../../../../InputComponents/VideoPresetInput/VideoPresetInput';
import VideoTuneInput from '../../../../InputComponents/VideoTuneInput/VideoTuneInput';
import VideoProfileInput from '../../../../InputComponents/VideoProfileInput/VideoProfileInput';
import VideoBFramesInput from '../../../../InputComponents/VideoBFramesInput/VideoBFramesInput';
import VideoFastPFrameSkipInput from '../../../../InputComponents/VideoFastPFrameSkipInput/VideoFastPFrameSkipInput';
import VideoThreadSliceInput from '../../../../InputComponents/VideoThreadSliceInput/VideoThreadSliceInput';
import VideoThreadsInput from '../../../../InputComponents/VideoThreadsInput/VideoThreadsInput';
import VideoMuxerDelayInput from '../../../../InputComponents/VideoMuxerDelayInput/VideoMuxerDelayInput';
import useProject from '../../../../../hooks/useProject';

const TranscoderVideoPanel = () => {
  const { project } = useProject();

  return (
    <div className="transcoder-video-panel">
      <div className="transcoder-video-panel-section level">
        <div className="transcoder-video-panel-section-content-value">
          <VideoQualityInput />
        </div>
      </div>

      {project.encoder.transcoderVideoQuality === VideoQualityEnum.BitrateControl && (
        <>
          <div className="transcoder-video-panel-section level">
            <div className="transcoder-video-panel-section-content-value">
              <VideoBitrateInput />
            </div>
          </div>

          <div className="transcoder-video-panel-section level">
            <div className="transcoder-video-panel-section-content-value">
              <VideoBitrateMaxInput />
            </div>
          </div>

          <div className="transcoder-video-panel-section level">
            <div className="transcoder-video-panel-section-content-value">
              <VideoBitrateBufferSizeInput />
            </div>
          </div>
        </>
      )}

      {project.encoder.transcoderVideoQuality === VideoQualityEnum.ConstantQuality && (
        <div className="transcoder-video-panel-section level">
          <div className="transcoder-video-panel-section-content-value">
            <VideoQualityCrfInput />
          </div>
        </div>
      )}

      {project.encoder.transcoderVideoQuality === VideoQualityEnum.FixedQuantizer && (
        <div className="transcoder-video-panel-section level">
          <div className="transcoder-video-panel-section-content-value">
            <VideoFixedQualityQpInput />
          </div>
        </div>
      )}

      {project?.createdByUser?.isAdmin === true && (
      <>
        <div className="transcoder-video-panel-section level">
          <div className="transcoder-video-panel-section-content-value">
            <VideoPixelFormatInput />
          </div>
        </div>
      </>
      )}

      <div className="transcoder-video-panel-section level">
        <div className="transcoder-video-panel-section-content-value">
          <VideoPresetInput />
        </div>
      </div>

      <div className="transcoder-video-panel-section level">
        <div className="transcoder-video-panel-section-content-value">
          <VideoTuneInput />
        </div>
      </div>

      <div className="transcoder-video-panel-section level">
        <div className="transcoder-video-panel-section-content-value">
          <VideoProfileInput />
        </div>
      </div>

      {project?.createdByUser?.isAdmin === true && (
      <>
        <div className="transcoder-video-panel-section level">
          <div className="transcoder-video-panel-section-content-value">
            <VideoBFramesInput />
          </div>
        </div>

        <div className="transcoder-video-panel-section level">
          <div className="transcoder-video-panel-section-content-value">
            <VideoFastPFrameSkipInput />
          </div>
        </div>

        <div className="transcoder-video-panel-section level">
          <div className="transcoder-video-panel-section-content-value">
            <VideoThreadSliceInput />
          </div>
        </div>

        <div className="transcoder-video-panel-section level">
          <div className="transcoder-video-panel-section-content-value">
            <VideoThreadsInput />
          </div>
        </div>

        <div className="transcoder-video-panel-section level">
          <div className="transcoder-video-panel-section-content-value">
            <VideoMuxerDelayInput />
          </div>
        </div>
      </>
      )}
    </div>
  );
};

export default React.memo(TranscoderVideoPanel);
